import {CallTrackingDataTable} from '../../@types'

export const processCallTime = (timeString: string) => {
    const time = timeString.replace(/\s+/g, '');
    const [hour, minute, second] = time.split(/[hms]/);
    return { hour: +hour, minute: +minute, second: +second };
};

export const processDataTable = (dataTable: CallTrackingDataTable[]) => {
    return dataTable.map(item => ({
        ...item,
        subscriber: item.subscriber === null ? "" : item.subscriber,
    }));
};